export const expiringAdmissionHeader = [
  {
    headerName: 'Sl No.',
    field: 'slNo',
    sortable: true,
  },
  {
    headerName: 'Student Name',
    field: 'studentName',
    sortable: true,
  },
  {
    headerName: 'Course',
    field: 'course',
    sortable: true,
  },
  {
    headerName: 'Total Required Sessions',
    field: 'totalRequiredSessions',
    sortable: true,
  },
  {
    headerName: 'Total Sessions Completed',
    field: 'totalSessionsCompleted',
    sortable: true,
  },
  {
    headerName: 'Sessions Completion %',
    field: 'sessionCompletion',
    sortable: true,
  },
  {
    headerName: 'SRO Sales Amount',
    field: 'sroSalesAmount',
    sortable: true,
  },
  {
    headerName: 'Total Fee Paid',
    field: 'totalFeePaid',
    sortable: true,
  },
  {
    headerName: 'Status',
    field: 'status',
    sortable: true,
  },
  {
    headerName: 'Remarks',
    field: 'remarks',
    sortable: true,
  },
];
